import { ChangeDetectionStrategy, Component, computed, Input, input } from '@angular/core';
import { ContentBlockBaseComponent } from '../content-block-base/content-block-base.component';
import { ImageComponent, ResizeHtmlImagesPipe } from '@teamfoster/sdk/image';
import { CookieNgrxModule } from '@teamfoster/sdk/cookie-ngrx';
import { TextUtilityModule } from '@teamfoster/sdk/text-utility';
import { ButtonModule } from '@teamfoster/sdk/button';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { NgClass } from '@angular/common';
import { YoutubeComponent } from 'src/app/standalone/components/youtube/youtube.component';

@Component({
  selector: 'app-content-block-cta',
  templateUrl: './content-block-cta.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  styleUrl: './content-block-cta.component.scss',
  imports: [
    ResizeHtmlImagesPipe,
    CookieNgrxModule,
    TextUtilityModule,
    ButtonModule,
    FromDictionaryPipe,
    ImageComponent,
    NgClass,
    YoutubeComponent,
    ImageComponent,
  ],
})
export class ContentBlockCtaComponent extends ContentBlockBaseComponent {
  hasContent$ = computed(() => {
    return this.block().intro || this.block().button?.url;
  });
}
